export const PERMISSIONS = {
  SUPER_ADMIN: 'super_admin',
  VIEW_AGENTS: 'view_agents',
  EDIT_AGENTS: 'edit_agents',
  CREATE_AGENTS: 'create_agents',
  DELETE_AGENTS: 'delete_agents',
  VIEW_CONVERSATIONS: 'view_conversations',
  VIEW_CONVERSATION_META: 'view_conversation_meta',
  VIEW_BILLING: 'view_billing',
  VIEW_SELF_COST_DATA: 'view_self_cost_data',
  VIEW_WIDGET_ANALYTICS: 'view_widget_analytics',
  MAKE_CALL: 'make_call',
  MAKE_CONFERENCE_CALL: 'make_conference_call',
  MANAGE_KNOWLEDGE: 'manage_knowledge',
  MANAGE_SCRAPER: 'manage_scraper',
  MANAGE_SIP_TRUNK: 'manage_sip_trunk',
  VIEW_DASHBOARD_ANALYTICS: 'view_dashboard_analytics',
  PROMPT_LIBRARY_ACCESS: 'prompt_library_access',
} as const;

export type PermissionValue = (typeof PERMISSIONS)[keyof typeof PERMISSIONS];
